const alertStatusesById = {
  2: 'Confirmed',
  3: 'Rejected'
};

export const LCRMTPlayersAlertsAfterReview = (actionType, selectedAlerts, filterStatuses, alerts, User, Modified, Assessment, Comment) => {
  alerts.forEach(item => {
    if (selectedAlerts.includes(item.AlertId)) {
      // eslint-disable-next-line no-param-reassign
      item.AlertStatus = alertStatusesById[actionType];
      // eslint-disable-next-line no-param-reassign
      item.User = User;
      // eslint-disable-next-line no-param-reassign
      item.Modified = Modified;
      // eslint-disable-next-line no-param-reassign
      item.Assessment = Assessment;
      // eslint-disable-next-line no-param-reassign
      item.Comment = Comment;
    }
  });
  return [...alerts];
};
